import React from "react";
export default function Loader({ label = "Chargement…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-neutral-400 gap-3">
      <div className="h-10 w-10 rounded-full border-2 border-neutral-700 border-t-[#5BC5F2] animate-spin" />
      <div className="text-sm">{label}</div>
    </div>
  );
}
